import z, { boolean, object, ZodTypeAny } from 'zod';

export const withIsEnabled = <TEnabled extends ZodTypeAny, TDisabled extends ZodTypeAny>(
  enabledSchema: TEnabled,
  disabledSchema: TDisabled,
) =>
  object({
    isEnabled: boolean().optional(),
  })
    .passthrough()
    .transform((value, context) => {
      const isEnabled = value.isEnabled ?? false;
      const branch = isEnabled ? enabledSchema : disabledSchema;
      const result = branch.safeParse(value);

      if (!result.success) {
        result.error.issues.forEach((issue) => {
          context.addIssue(issue);
        });
        return z.NEVER;
      }

      return { ...result.data, isEnabled } as
        | (z.infer<TEnabled> & { isEnabled: true })
        | (z.infer<TDisabled> & { isEnabled: false });
    });
